import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  label?: string;
  tone?: "light" | "dark";
};
export function Countdown({
  label = "Special offer ends in:",
  tone = "light"
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    unit: "Hours"
  }, {
    value: minutes,
    unit: "Minutes"
  }, {
    value: seconds,
    unit: "Seconds"
  }];
  const dark = tone === "dark";
  return <div className="mx-auto w-full max-w-md text-center" role="timer" aria-live="off" data-id="element-98" data-mp="3h18uupzspy5x">
      <p className={`flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wide ${dark ? "text-gold" : "text-alert"}`} data-id="element-99" data-mp="324870xkq6ncq">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-100" data-mp="10cbrzdzcmvd7" />
        {label}
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" data-id="element-101" data-mp="10ailpzsned5q">
        {units.map((u, i) => <React.Fragment key={u.unit} data-id="element-102" data-mp="y16k57u8w1pn" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-103" data-mp="y04zqcrca2v9">
              <span className={`flex h-20 w-20 items-center justify-center rounded-xl font-display text-4xl font-black tabular-nums sm:h-24 sm:w-24 sm:text-5xl ${dark ? "bg-white text-navy" : "bg-navy text-white"}`} data-id="element-104" data-mp="t23dxk2j3pg3">
                {u.value}
              </span>
              <span className={`mt-1.5 text-xs font-semibold uppercase ${dark ? "text-white/70" : "text-muted"}`} data-id="element-105" data-mp="f1iy8wrwu9qt">
                {u.unit}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-5 font-display text-3xl font-black sm:pt-7 ${dark ? "text-white" : "text-navy"}`} data-id="element-106" data-mp="o3s4vbk25iyx">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}